import config from '../utils/config'
import request from '../utils/request'
import {browserHistory} from "react-router";
import lodash from 'lodash'
import {store} from '../store';
import {fetchLoginedUser} from "../redux/actions/user";
import {fetchCMEnums} from "../redux/actions/cmenums";
import AvailableMembershipForbidden from "../containers/AvailableMembershipForbidden";
import moment from 'moment';
import {savedRequest} from "../redux/actions/global";
import {message} from "antd/lib/index";
import {vaildVas,findValidity} from "./vas";
import {findUniqueField,findEventCiForm} from "./evt";
import { isWeixinBrowser, queryStringParam, replaceStringParam } from "../utils/index";

import {saveBankLog} from "./banklog";
import {findSignature} from "./signature";

const {api} = config
const {resetMobile, resetEmail, prematchMobile, prematchEmail,
    uploadFile, userLogin,wxLoginQrcode,wxLoginUserInfo, thirdPlatformLogin, userLogout,
    smsCaptcha, emailCaptcha, thirdPlatformLoginUrl, feeRate,isSMember} = api


export const MsgActionType = {
    REGISTER: "REGISTER_CPT",
    LOGIN: "LOGIN_CPT",
    FORGET_PASSWD: "FORGET_PASSWD_CPT",
    BIND_PHONE: "BIND_PHONE_CPT",
    UNBIND_PHONE: "UNBIND_PHONE_CPT",
    BIND_EMAIL: "BIND_EMAIL_CPT",
    UNBIND_EMAIL: "UNBIND_EMAIL_CPT",
    BIND_BANK_CARD: "BIND_BANK_CARD_CPT",
    EVENT_ATTENDEE: "EVENT_ATTEND_CPT",
    EVENT_CHECKIN: "EVENT_CHECKIN_CPT",
    EVENT_TICKET: "EVENT_TICKET_NTF",
    EVENT_ATTENDEE_IMT: "EVENT_ATTENDEE_IMT_NTF",
    EVENT_ATTENDEE_EXP: "EVENT_ATTENDEE_EXP_NTF",
    COMMON: "COMMON_CMM",
    MODIFY_PASSWD_CPT:"MODIFY_PASSWD_CPT",
    REMOVE_ACCOUNT_CPT:"REMOVE_ACCOUNT_CPT",
}

export const BizRegex = {
    emailOrMobile: /^(\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*)|(\d{7,15})$/,
    mobile: /^\d{6,20}$/,
    phone: /^[0-9\+-\\(\\)]{5,20}$/,
    email: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
    loginName: /^[a-zA-Z\u4e00-\u9fa5][\w\u4e00-\u9fa5]+$/,
    captcha: /^\d{1,6}$/,
    noblank: /^[^\s]*$/,
}


export const clearAuth = (redirectLoginPage, isSaveRequestPathname = false) => {
    localStorage.removeItem('userId');
    localStorage.removeItem('userPrincipal');
    localStorage.removeItem('token');
    localStorage.removeItem('roles');
    localStorage.removeItem('permissions');

    const currentLocation = browserHistory.getCurrentLocation();


    if (isSaveRequestPathname && currentLocation) {
        store.dispatch(savedRequest(`${currentLocation.pathname}${currentLocation.search}`))
    } else {
        store.dispatch(savedRequest(""))
    }

    if (redirectLoginPage) {
        browserHistory.push("/login");
    }
}

export const fefreshAuth = () => {
    store.dispatch(fetchLoginedUser());
};

export const auth = (data) => {
    localStorage.setItem('userId', data.principal.id);
    localStorage.setItem('userPrincipal', JSON.stringify(data.principal));
    localStorage.setItem('token', data.token);
    localStorage.setItem('roles', data.roles);
    localStorage.setItem('permissions', data.permissions);
    store.dispatch(fetchCMEnums());
    store.dispatch(fetchLoginedUser()).then((res) => {
        const redirectPath = store.getState().global && store.getState().global.savedRequest ? `${store.getState().global.savedRequest}` : "";
        store.dispatch(savedRequest(""))
        if(res.value.data.subAccount){
            browserHistory.push("/subaccount-checkinpoints")
        }else {
            if (redirectPath) {
                browserHistory.push(redirectPath);
            } else {
                browserHistory.push("/");
            }
        }



    })
}
export const getAttendeeeNum = () => {
    let conut=0;
    if(store.getState().loginedUser.data){
        if(store.getState().loginedUser.data.membership.membershipId == '92'){
            conut=store.getState().loginedUser.data.limitConfig.eventAttendeeCountSeniorMember;
        }else if(store.getState().loginedUser.data.membership.membershipId == '91'){
            conut=store.getState().loginedUser.data.limitConfig.eventAttendeeCountMember;
        }else {
            conut=store.getState().loginedUser.data.limitConfig.eventAttendeeCount;
        }
    }
    return conut;
}

export const isSuperuser = (loginedUser) => {
    return loginedUser && loginedUser.data && loginedUser.data.id == 1;
}
export const isSubAccount = (loginedUser) => {
    return loginedUser && loginedUser.data && loginedUser.data.subAccount;
}

export const isVasValidity = (svcVasId, callback) => {
    vaildVas({vasId: svcVasId}).then(res => {
        if (res.code == 200) {
            callback(res.data)
        } else {
            callback(false)
        }
    }).catch(err => {
        callback(false)
    })
}
export const isValidity = (svcVas, callback) => {
    findValidity({svcVas: svcVas}).then(res => {
        if (res.code == 200) {
            callback(res.data)
        } else {
            callback(false)
        }
    }).catch(err => {
        callback(false)
    })
}
export const isValidityKey = (values, callback) => {
    findValidity(values).then(res => {
        if (res.code == 200) {
            callback(res.data)
        } else {
            callback(false)
        }
    }).catch(err => {
        callback(false)
    })
}

export const getTextField = (eventId, callback) => {
    findEventCiForm({eventId: eventId}).then(res => {
        if (res.code == 200) {
            let arr=res.data.fields.filter(f=>f.type=='TEXT' && !lodash.startsWith(f.constraint, "img"));
            callback(arr)
        } else {
            callback([])
        }
    }).catch(err => {
        callback([])
    })
}

export const isUniqueField = (eventId, callback) => {
    findUniqueField({eventId: eventId}).then(res => {
        if (res.code == 200) {
            callback(res.data)
        } else {
            callback({})
        }
    }).catch(err => {
        callback({})
    })
}
export const isWeixinConfig = (url, callback) => {
    findSignature({url: encodeURI(url),debugging:url}).then(res => {
        if (res.code == 200) {
            window.wx.config({
                debug: false,// 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: res.data.appId, // 必填，公众号的唯一标识
                timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                signature: res.data.signature,// 必填，签名，见附录1
                jsApiList: ['getLocation','hideAllNonBaseMenuItem'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });

            window.wx.ready(()=>{
                callback(true)
            })
            window.wx.error(function(res){
                callback(false)
            });
        } else {
            callback(false)
        }
    }).catch(err => {
        callback(false)
    })
}
export const bankLog = (data) => {
    saveBankLog(data).then(res => {
    }).catch(err => {
    })
}


export const getUserPrincipal = () => {
    const userPrincipalStr = localStorage.getItem("userPrincipal");
    if (userPrincipalStr) {
        return JSON.parse(userPrincipalStr);
    }
    return null;
}


export const loginUserHasRole = (role) => {
    const rolesStr = localStorage.getItem('roles');
    if (!rolesStr) {
        return false;
    }
    const roles = rolesStr.split(",");
    if (roles.length == 0) {
        return false;
    }
    return lodash.indexOf(roles, role) != -1;
}

export const loginUserIsManager = () => {
    const rolesStr = localStorage.getItem('roles');
    if (!rolesStr) {
        return false;
    }
    const roles = rolesStr.split(",");
    if (roles.length == 0 || (roles.length == 1 && roles[0] == "normal")) {
        return false;
    }
    return true;
}
export const getShareUrl = () => {
    //自定义分享链接
    let _link = window.location.href;
    let userId = localStorage.getItem('attendeeUserId');
    if (userId) {
        if (queryStringParam('levelOne')) {
            if (queryStringParam('levelTwo')) {
                _link = replaceStringParam('levelTwo', userId);
            } else {
                _link = window.location.href + '&levelTwo='+userId;
            }

        } else {
            if (window.location.href.indexOf('?') > -1) {
                _link = `${window.location.href}&levelOne=${userId}`;
            } else {
                _link =`${window.location.href}?levelOne=${userId}`;;
            }

        }
    }
    return _link;
}
//  表单过滤
export const formFilter = (data) => {
    if(data.tickets.length == 1){
        let ticketId = data.tickets[0].ticketingId;
        data.form.fields = data.form.fields.filter(obj=>{
            let staus = false;
            if(obj.unique){
                staus = true;
            }else if(!obj.ticketingIds){
                staus = true;
            }else{
                if(obj.ticketingIds.length == 0){
                    staus = true;
                }else{
                    staus = obj.ticketingIds.some(t=>t == ticketId)
                }
            }
            return staus;
        })

    }
}

/**
 * 查找通讯录记录
 */
export async function findFile(filename) {
    return request({
        url: uploadFile, method: 'get', data: {
            filename: filename
        }
    })
}

/**
 * 登录
 */
export async function login(params) {
    return request({url: userLogin, method: 'post', data: params, timeout: 3000,})
}

export async function loginByOAuth(params) {
    return request({url: thirdPlatformLogin, method: 'get', data: params,})
}
export async function findWxLoginQrcode(params) {
    return request({url: wxLoginQrcode, method: 'get', data: params,})
}
export async function findWxLoginUserInfo(params) {
    return request({url: wxLoginUserInfo, method: 'get', data: params,})
}

/**
 * 注销
 */
export async function logout(params) {
    return request({url: userLogout, method: 'delete', data: params,})
}

/**
 * 费率
 */
export async function getFeeRate(params) {
    return request({url: feeRate, method: 'get', data: params,})
}


export async function sendSmsCaptcha(msgActionType, mobile) {
    return request({
        url: smsCaptcha, method: 'post', data: {
            type: msgActionType,
            mobile: mobile
        }
    })
}

export async function sendEmailCaptcha(msgActionType, email) {
    return request({
        url: emailCaptcha, method: 'post', data: {
            type: msgActionType,
            email: email
        }
    })
}


export async function getThirdPlatformOauthLoginUrl(platform, redirectUri) {
    return request({
        url: thirdPlatformLoginUrl, method: 'get', data: {
            platform: platform,
            redirectUri: redirectUri
        }
    })
}

//匹配手机或邮箱
export async function getPrematchMobile(captcha, data) {
    return request({
        url: `${prematchMobile}?captcha=${captcha}`, method: 'post', data: data
    })
}

export async function getPrematchEmail(captcha, data) {
    return request({
        url: `${prematchEmail}?captcha=${captcha}`, method: 'post', data: data
    })
}

//重置手机或邮箱
export async function setResetMobile(params) {
    return request({url: resetMobile, method: 'post', data: params,})
}

export async function setResetEmail(params) {
    return request({url: resetEmail, method: 'post', data: params,})
}
export async function findIsSMember(params) {
    return request({url: isSMember, method: 'get', data: params,})
}


// WEBPACK FOOTER //
// ./src/services/global.js